// Utils
import { deleteAccessTokenCookie } from '../utils/cookie';

export const apiLogout = () => {
  deleteAccessTokenCookie();
  window.location.href = '/';
};
